import React from 'react';
import { Smartphone, ArrowRight } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

export const FeaturedProduct = () => {
  return (
    <section className="py-24 bg-[#0D1115] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat'] font-bold text-4xl sm:text-5xl text-[#F5F7F8] mb-6">
            Featured <span className="text-[#30D5C8]">Product</span>
          </h2>
          <p className="text-[#CBD3D9] text-lg sm:text-xl font-['Open_Sans'] max-w-3xl mx-auto">
            Introducing our mobile app for field workers
          </p>
        </div>

        <Card className="bg-gradient-to-br from-[#1A2733] to-[#0D1115] border-[#30D5C8]/30 p-8 sm:p-12 hover:border-[#30D5C8]/50 transition-all duration-300 max-w-5xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            {/* Left side - Icon/Visual */}
            <div className="flex items-center justify-center">
              <div className="relative">
                <div className="w-48 h-48 bg-[#30D5C8]/10 rounded-3xl flex items-center justify-center backdrop-blur-sm border border-[#30D5C8]/30">
                  <Smartphone className="text-[#30D5C8]" size={96} />
                </div>
                <div className="absolute -top-4 -right-4 w-24 h-24 bg-[#30D5C8] rounded-full blur-[60px] opacity-30" />
              </div>
            </div>

            {/* Right side - Content */}
            <div className="space-y-6">
              <div>
                <div className="inline-block bg-[#30D5C8]/10 border border-[#30D5C8]/30 rounded-full px-4 py-2 mb-4">
                  <span className="text-[#30D5C8] text-sm font-['Montserrat'] font-semibold">
                    MOBILE APP
                  </span>
                </div>
                <h3 className="font-['Montserrat'] font-bold text-3xl sm:text-4xl text-[#F5F7F8] mb-3">
                  PayFlow App
                </h3>
                <p className="text-[#30D5C8] text-xl sm:text-2xl font-['Montserrat'] font-semibold mb-4">
                  Time Tracking & Pay Estimation
                </p>
                <p className="text-[#CBD3D9] text-lg font-['Open_Sans'] leading-relaxed">
                  Track hours, manage projects, and estimate real take-home pay. Built specifically for construction and industrial workers who need accurate time tracking and paycheck estimates.
                </p>
              </div>

              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-[#30D5C8]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2 h-2 bg-[#30D5C8] rounded-full" />
                  </div>
                  <p className="text-[#CBD3D9] font-['Open_Sans']">
                    One-tap clock in/out with project tracking
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-[#30D5C8]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2 h-2 bg-[#30D5C8] rounded-full" />
                  </div>
                  <p className="text-[#CBD3D9] font-['Open_Sans']">
                    Accurate paycheck estimation with tax calculations
                  </p>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-6 h-6 bg-[#30D5C8]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2 h-2 bg-[#30D5C8] rounded-full" />
                  </div>
                  <p className="text-[#CBD3D9] font-['Open_Sans']">
                    Support for OT, per diem, and travel pay
                  </p>
                </div>
              </div>

              <div className="pt-4">
                <Button
                  onClick={() => window.location.href = '/payflow'}
                  className="bg-[#30D5C8] text-[#0D1115] hover:bg-[#30D5C8]/90 font-['Montserrat'] font-bold text-lg px-8 py-6 rounded-lg group"
                >
                  View PayFlow
                  <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
                </Button>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </section>
  );
};
